import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import useContentCrmObject from '../hooks/useContentCrmObject';
import { useSelector } from 'react-redux';
import { getUnifiedPublishType } from '../../../redux/selectors/publishSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This modal is configured to be only used by ContentTypes on CMP platform
 */
const PublishConfirmModal = ({
  publishButtonTextKey,
  confirmPublishActionProps: {
    publishConfirmModalBodyContent,
    publishConfirmDisabled,
    publishConfirmDisabledTooltip
  },
  publish,
  closeModal
}) => {
  const {
    contentCrmObjectPublishType
  } = useContentCrmObject();
  const unifiedPublishType = useSelector(getUnifiedPublishType);
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 550,
    "data-selenium": "confirm-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `publishConfirmModal.header.${contentCrmObjectPublishType || unifiedPublishType}`
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: publishConfirmModalBodyContent
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(UITooltip, {
          disabled: !publishConfirmDisabled,
          title: publishConfirmDisabledTooltip,
          children: /*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "publish-confirm-button",
            "data-onboarding": "publish-confirm-button",
            use: "primary",
            disabled: publishConfirmDisabled,
            onClick: () => {
              publish(contentCrmObjectPublishType || unifiedPublishType);
              closeModal();
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: publishButtonTextKey
            })
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "publish-confirm-secondary-button",
          use: "secondary",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publishConfirmModal.footer.cancel"
          })
        })]
      })
    })]
  });
};
export default PublishConfirmModal;